import axios from "axios";
import { supabase } from "./supabaseClient.js";

const baseURL = import.meta.env.VITE_API_BASE_URL || "/api";

const api = axios.create({
  baseURL
});

api.interceptors.request.use(async (config) => {
  if (!supabase) return config;
  const { data } = await supabase.auth.getSession();
  const token = data?.session?.access_token;
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export async function fetchOrgInfo(orgSlug) {
  const { data } = await api.get(`/org/${orgSlug}`);
  return data;
}

export async function fetchShopList(orgSlug) {
  const { data } = await api.get(`/org/${orgSlug}/config`);
  return data;
}

export async function fetchShopConfig(orgSlug, shopId) {
  const { data } = await api.get(`/org/${orgSlug}/config/${shopId}`);
  return data;
}

export async function fetchMonthlyAvailability(orgSlug, shopId, hairdresserId, appointmentTypeId, month, year) {
  const { data } = await api.get(`/org/${orgSlug}/availability/monthly`, {
    params: {
      shop_id: shopId,
      hairdresser_id: hairdresserId,
      appointment_type_id: appointmentTypeId,
      month,
      year
    }
  });
  return data;
}

export async function createBooking(orgSlug, body) {
  const { data } = await api.post(`/org/${orgSlug}/bookings`, body);
  return data;
}

// --- Admin ---

export async function fetchShops() {
  const { data } = await api.get("/admin/shops");
  return data;
}

export async function fetchOrganizations() {
  const { data } = await api.get("/admin/organizations");
  return data;
}

export async function createOrganization(body) {
  const { data } = await api.post("/admin/organizations", body);
  return data;
}

export async function fetchAdminOrganizationBySlug(orgSlug) {
  const { data } = await api.get(`/admin/organizations/by-slug/${orgSlug}`);
  return data;
}

export async function fetchCurrentUserInfo() {
  const { data } = await api.get("/admin/me");
  return data;
}

export async function createOrgAdmin(orgId, body) {
  const { data } = await api.post(`/admin/organizations/${orgId}/admins`, body);
  return data;
}

export async function fetchOrgAdmins(orgId) {
  const { data } = await api.get(`/admin/organizations/${orgId}/admins`);
  return data;
}

export async function createShop(body) {
  const { data } = await api.post("/admin/shops", body);
  return data;
}

export async function fetchShop(shopId) {
  const { data } = await api.get(`/admin/shops/${shopId}`);
  return data;
}

export async function updateShop(shopId, body) {
  const { data } = await api.put(`/admin/shops/${shopId}`, body);
  return data;
}

export async function deleteShop(shopId) {
  await api.delete(`/admin/shops/${shopId}`);
}

export async function createHairdresser(shopId, body) {
  const { data } = await api.post(`/admin/shops/${shopId}/hairdressers`, body);
  return data;
}

export async function fetchHairdresser(shopId, hairdresserId) {
  const { data } = await api.get(`/admin/shops/${shopId}/hairdressers/${hairdresserId}`);
  return data;
}

export async function updateHairdresser(shopId, hairdresserId, body) {
  const { data } = await api.put(`/admin/shops/${shopId}/hairdressers/${hairdresserId}`, body);
  return data;
}

export async function createAppointmentType(shopId, body) {
  const { data } = await api.post(`/admin/shops/${shopId}/appointment-types`, body);
  return data;
}

export async function updateAppointmentType(shopId, typeId, body) {
  const { data } = await api.put(`/admin/shops/${shopId}/appointment-types/${typeId}`, body);
  return data;
}
